'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var getChildren = function getChildren() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      index = _ref.index,
      _ref$idField = _ref.idField,
      idField = _ref$idField === undefined ? 'id' : _ref$idField,
      _ref$parentField = _ref.parentField,
      parentField = _ref$parentField === undefined ? 'parent' : _ref$parentField;

  return function (rows) {
    if (!rows.length) {
      return [];
    }

    // See if the next item points to the current one.
    // This relies on rows order!
    var currentIndex = index;
    var currentItem = rows[currentIndex];
    var nextItem = rows[currentIndex + 1];

    if (!currentItem) {
      return [];
    }

    var previousParents = _defineProperty({}, currentItem[idField], true);
    var ret = [];

    while (nextItem && previousParents[nextItem[parentField]]) {
      ret.push(nextItem);

      previousParents[nextItem[idField]] = true;

      currentIndex += 1;
      currentItem = rows[currentIndex];
      nextItem = rows[currentIndex + 1];
    }

    return ret;
  };
};

exports.default = getChildren;